import { ArrowRight } from "lucide-react";
import "./Services.css";

const services = [
  {
    icon: "🌿",
    title: "Gardening",
    desc: "Perawatan taman rutin dan profesional untuk hunian dan perkantoran Anda.",
    img: "https://plus.unsplash.com/premium_photo-1678652879556-11451dff2f6a?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    icon: "🌳",
    title: "Landscaping",
    desc: "Desain dan pengerjaan landscape taman yang estetik dan berkelanjutan.",
    img: "https://images.unsplash.com/photo-1623358519330-00f61d89396b?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    icon: "🌱",
    title: "Turfing",
    desc: "Pemasangan rumput sintetis maupun alami berkualitas tinggi.",
    img: "https://images.unsplash.com/photo-1689728318937-17d24bc0a65c?q=80&w=686&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    icon: "🌲",
    title: "Tree Care",
    desc: "Penanganan pohon profesional: reboisasi, transplantasi, dan peremajaan.",
    img: "https://images.unsplash.com/photo-1617576683096-00fc8eecb3af?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export default function Services() {
  return (
    <section className="services" id="layanan">
      <div className="container">
        <div className="services__head">
          <span className="eyebrow">Layanan Kami</span>
          <h2 className="services__title">Solusi Penghijauan untuk Rumah &amp; Bisnis</h2>
          <p className="services__sub">Kami menyediakan layanan penghijauan lengkap dari perancangan hingga perawatan berkala.</p>
        </div>

        <div className="services__grid">
          {services.map((s) => (
            <div className="svc-card" key={s.title}>
              <div className="svc-card__img">
                <img src={s.img} alt={s.title} />
                <div className="svc-card__notch">
                  <span className="svc-card__notch-icon">{s.icon}</span>
                </div>
              </div>
              <div className="svc-card__body">
                <h3 className="svc-card__title">{s.title}</h3>
                <p className="svc-card__desc">{s.desc}</p>
                <a href="#kontak" className="svc-card__link">Pelajari <ArrowRight size={14} /></a>
              </div>
            </div>
          ))}
        </div>

        <div className="services__cta">
          <a href="#kontak" className="btn btn-green">Mulai Proyek Anda</a>
          &nbsp;&nbsp;
          <a href="#portofolio" className="btn btn-outline-green">Lihat Semua</a>
        </div>
      </div>
    </section>
  );
}
